import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import dazuRecliningBuddha from '../assets/dazu/dazu-reclining-buddha.jpg';

function normalizeResults(state) {
  if (Array.isArray(state?.results)) {
    return state.results;
  }
  if (Array.isArray(state?.gameEnded?.results)) {
    return state.gameEnded.results;
  }
  if (Array.isArray(state?.payload?.results)) {
    return state.payload.results;
  }
  return [];
}

const SettlementPage = () => {
  const { roomCode = '' } = useParams();
  const location = useLocation();
  const results = normalizeResults(location.state);
  const sortedResults = results.slice().sort((a, b) => (a.rank || 99) - (b.rank || 99));

  return (
    <main className="page-shell page-shell--themed settlement-page">
      <header className="page-hero room-header">
        <div>
          <p className="eyebrow">结算</p>
          <h1>{roomCode}</h1>
          <p className="muted">服务器记录的最终筹码数。</p>
        </div>
        <Link
          className="secondary-button secondary-button--stone link-button"
          to="/"
        >
          游戏库
        </Link>
      </header>

      <div className="cultural-banner cultural-banner--compact">
        <img src={dazuRecliningBuddha} alt="Dazu Rock Carvings" />
        <div className="cultural-banner__text">
          <p className="eyebrow">结算时刻</p>
          <p className="muted">在石窟的寂静中回顾每一局的得失。</p>
        </div>
      </div>

      {sortedResults.length === 0 ? (
        <section className="empty-state">
          <h2>暂无结算数据</h2>
          <p className="muted">
            牌桌结束游戏后会带着结果打开此页面。统计页面会单独记录已完成游戏。
          </p>
          <Link
            className="secondary-button secondary-button--stone link-button"
            to="/"
          >
            返回游戏库
          </Link>
        </section>
      ) : (
        <section className="settlement-card data-card">
          <div className="section-heading">
            <h2>结果</h2>
            <span>{sortedResults.length} 名玩家</span>
          </div>
          <div className="settlement-list">
            {sortedResults.map((result) => (
              <article className="settlement-row" key={result.userId}>
                <div className="rank-badge">#{result.rank}</div>
                <div>
                  <strong>{result.displayName || result.username || `玩家 ${result.userId}`}</strong>
                  <p className="muted">用户 {result.userId}</p>
                </div>
                <div className="settlement-numbers">
                  <span>{result.finalChips} 筹码</span>
                  <strong className={result.netChips >= 0 ? 'net-positive' : 'net-negative'}>
                    {result.netChips >= 0 ? '+' : ''}{result.netChips}
                  </strong>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}
    </main>
  );
};

export default SettlementPage;
